export default "/fonts/PublicSans-SemiBold.ttf?4e17ebd61fd1388761499f709f010387";